"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Menu = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var index_1 = require("../index");
function Menu(props) {
    var handleChangeMode = function (result) {
        console.log(result);
    };
    var data = props.data;
    return (React.createElement("div", null,
        data.type === "main_menu" && (React.createElement(index_1.MainMenu, { data: data, onClick: handleChangeMode })),
        data.type === "sub_menu" && (React.createElement(index_1.SubMenu, { data: data, onClick: handleChangeMode }))));
}
exports.Menu = Menu;
//# sourceMappingURL=index.js.map